import { IConfigName } from './interface/field-type-object';

interface IDefaultDataObject {
  configName: IConfigName;
  required: boolean;
  type: string;
}

const defaultData: IDefaultDataObject = {
  configName: IConfigName.Phone,
  required: false,
  type: 'string',
};

interface IDefaultConfigObject {
  displayType: string;
  format: string;
  phoneCountryCode: string;
  allowControlCountryCode: boolean;
}

const defaultConfig: IDefaultConfigObject = {
  format: 'phone',
  displayType: 'line',
  phoneCountryCode: 'PH',
  allowControlCountryCode: true,
};

const value = {
  title: 'Phone',
  icon: {
    black: require('../../icons/black/mobile.png'),
    white: require('../../icons/white/mobile.png'),
    blue: require('../../icons/blue/mobile.png'),
  },
  style: {
    width: '20px',
    height: '20px'
  },
  defaultData,
  defaultConfig
}

export default value;